import React, { Component, PropTypes } from 'react';
import Image from '../../components/image/image';
import { DateFormatter } from '../../utils/date';
import Pixeltext from '../../components/svg/pixeltext';
import Profile from './profile';
import axios from 'axios';
import css from './hof.scss';
import { profilesRoute } from '../../routes/index';
import { Link } from 'react-router';

import {uniqueId} from 'lodash';

import baseUrl from '../../utils/baseUrl';
let url = baseUrl + '/api/hof';

export default class Hof extends Component {
	static propTypes = {};
	
	constructor(props) {
		super(props);

		this.uniq = uniqueId();

		this.state = {
			profiles: [],
			active: false,
		};
	}

	componentWillMount() {
		axios.get(url).then((response) => {
			this.setState({
				profiles: response.data.profiles,
			});
		}).catch((response) => {
			console.log('fetching hof error');
			console.log(response);
		});
	}

	render() {

		if (this.state.profiles) {
			let profiles = this.state.profiles;

			return (
				<section className='hof hof span14'>
					<ul className='hof__interview-holder'>
						{profiles.map((profile, i) => this.renderProfile(profile, i))}
					</ul>
				</section>
			);
		} else {
			return (
				<section className='hof hof span14'>
					Loading...
				</section>
			);
		}
	}

	renderProfile(profile, i) {
		let uid = 'hof-profile-' + i;

		return (
			<Profile browser={this.props.browser} key={uid} profile={profile} className='hof__interview' />
		);
	}

	moreClick(e, text, content, right) {
		e.preventDefault();
		this.setState({
			active: !this.state.active,
		});
		
	}
}



/** WEBPACK FOOTER **
 ** ./frontend/components/hof/hof.js
 **/